import { Purchase, PurchaseCustomer } from "@modules/purchase/types/Purchase";
import dealCustomerTypeEnum from "@common/enums/DealCustomerTypeEnum";

const TryFindCustomerByDealCustomerType = (
  dealCustomerType: number,
  purchase: Purchase
): PurchaseCustomer | undefined => {
  return purchase.customers.find(
    (applicant) => applicant.typeId === dealCustomerType
  );
};

export function GetMainApplicant(purchase: Purchase): PurchaseCustomer {
  const customer = TryFindCustomerByDealCustomerType(
    dealCustomerTypeEnum.MainApplicant,
    purchase
  );

  if (!customer) {
    throw Error(
      `Main applicant not found on purchase with id of ${purchase.id}`
    );
  }

  return customer;
}

export const TryGetSeller = (purchase: Purchase): PurchaseCustomer | null => {
  const customer = TryFindCustomerByDealCustomerType(
    dealCustomerTypeEnum.Seller,
    purchase
  );

  return customer ?? null;
};
